import React from 'react';

import styled from 'styled-components';

import Header from 'common/Header';
import { useAppSelector } from 'store/hook';

import OverviewHeaderBreadcrumbs from './OverviewHeaderBreadcrumbs';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--line-gray);
`;

const OverviewHeader = () => {
  const { selectedCommunity } = useAppSelector((state) => state.global);

  return (
    <Container>
      <Header title={selectedCommunity?.name || ''} breadcrumbs={<OverviewHeaderBreadcrumbs />}></Header>
    </Container>
  );
};

export default OverviewHeader;
